import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "relative",
  ref: "root"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "truncate inline-flex items-center gap-1.5" }
const _hoisted_4 = {
  key: 0,
  class: "size-4 text-royal-blue-600 shrink-0",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_5 = { class: "flex items-center justify-between mb-2" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = {
  class: "relative",
  "data-dp-dropdown": ""
}
const _hoisted_8 = {
  key: 0,
  class: "absolute left-0 top-full mt-1 z-10 max-h-56 w-36 overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black/10"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "relative",
  "data-dp-dropdown": ""
}
const _hoisted_11 = {
  key: 0,
  ref: "yearList",
  class: "absolute left-0 top-full mt-1 z-10 max-h-56 w-24 overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black/10"
}
const _hoisted_12 = ["data-year", "onClick"]
const _hoisted_13 = { class: "grid grid-cols-7 gap-0.5 text-center text-xs text-gray-500 mb-1" }
const _hoisted_14 = { class: "grid grid-cols-7 gap-0.5" }
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { class: "mt-3 flex justify-between text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarDaysIcon = _resolveComponent("CalendarDaysIcon")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      id: _ctx.id,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      class: _normalizeClass([
                'flex w-full items-center justify-between rounded-md bg-white px-3 py-1.5 text-left text-base outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 cursor-pointer',
                _ctx.error ? 'outline-red-300 text-red-900 focus:outline-red-600 pr-10' : '',
                _ctx.displayValue ? 'text-gray-900' : (_ctx.showEmptyLabel ? 'text-gray-700' : 'text-gray-400')
            ])
    }, [
      _createElementVNode("span", _hoisted_3, [
        (_ctx.showEmptyLabel)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[7] || (_cache[7] = [
              _createElementVNode("path", { d: "M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.739-8-4.585 0-4.585 8 0 8 5.606 0 7.644-8 12.74-8z" }, null, -1)
            ])))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.displayValue || (_ctx.showEmptyLabel ? _ctx.emptyLabel : _ctx.placeholder)), 1)
      ]),
      _createVNode(_component_CalendarDaysIcon, {
        class: "ml-2 size-4 shrink-0 text-gray-400",
        "aria-hidden": "true"
      })
    ], 10, _hoisted_2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "popup",
            class: "fixed z-100 w-72 rounded-md bg-white p-3 shadow-lg ring-1 ring-black/10",
            style: _normalizeStyle(_ctx.popupStyle)
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args))),
                class: "p-1 rounded hover:bg-gray-100 cursor-pointer"
              }, [
                _createVNode(_component_ChevronLeftIcon, { class: "size-4 text-gray-600" })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDropdown('month'))),
                    class: "inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-medium text-gray-900 hover:bg-gray-100 cursor-pointer"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.monthNames[_ctx.viewMonth]) + " ", 1),
                    _createVNode(_component_ChevronDownIcon, { class: "size-3 text-gray-500" })
                  ]),
                  (_ctx.dropdown === 'month')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthNames, (m, i) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: i,
                            type: "button",
                            onClick: ($event: any) => (_ctx.pickMonth(i)),
                            class: _normalizeClass(['block w-full text-left px-3 py-1.5 text-sm cursor-pointer', i === _ctx.viewMonth ? 'bg-royal-blue-50 text-royal-blue-600 font-medium' : 'text-gray-900 hover:bg-gray-100'])
                          }, _toDisplayString(m), 11, _hoisted_9))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDropdown('year'))),
                    class: "inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-medium text-gray-900 hover:bg-gray-100 cursor-pointer"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.viewYear) + " ", 1),
                    _createVNode(_component_ChevronDownIcon, { class: "size-3 text-gray-500" })
                  ]),
                  (_ctx.dropdown === 'year')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearRange, (y) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: y,
                            type: "button",
                            "data-year": y,
                            onClick: ($event: any) => (_ctx.pickYear(y)),
                            class: _normalizeClass(['block w-full text-left px-3 py-1.5 text-sm cursor-pointer', y === _ctx.viewYear ? 'bg-royal-blue-50 text-royal-blue-600 font-medium' : 'text-gray-900 hover:bg-gray-100'])
                          }, _toDisplayString(y), 11, _hoisted_12))
                        }), 128))
                      ], 512))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args))),
                class: "p-1 rounded hover:bg-gray-100 cursor-pointer"
              }, [
                _createVNode(_component_ChevronRightIcon, { class: "size-4 text-gray-600" })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdayNames, (d, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: i,
                  class: "py-1"
                }, _toDisplayString(d), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: i,
                  type: "button",
                  disabled: day.disabled || !day.inMonth,
                  onClick: ($event: any) => (_ctx.selectDay(day)),
                  class: _normalizeClass([
                        'h-8 w-8 rounded-full text-sm flex items-center justify-center',
                        day.disabled || !day.inMonth ? 'cursor-not-allowed opacity-30 text-gray-500' : 'cursor-pointer text-gray-900 hover:bg-gray-100',
                        day.isSelected ? '!bg-royal-blue-600 !text-white !opacity-100 hover:!bg-royal-blue-700' : '',
                        day.isToday && !day.isSelected && !day.disabled ? 'ring-1 ring-royal-blue-500' : ''
                    ])
                }, _toDisplayString(day.day), 11, _hoisted_15))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectToday && _ctx.selectToday(...args))),
                class: "text-royal-blue-600 hover:underline cursor-pointer"
              }, _toDisplayString(_ctx.$t('datepicker.today')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
                class: "text-gray-500 hover:underline cursor-pointer"
              }, _toDisplayString(_ctx.$t('datepicker.clear')), 1)
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 512))
}